module.exports = __webpack_public_path__ + "img/11.d7abe077.jpg";